import { j as m } from "./jsx-runtime-944c88e2.js";
import * as s from "react";
import p, { forwardRef as n, createElement as d } from "react";
import { k as f } from "./index-a0534bb4.js";
import { w as c } from "./form-field-wrapper.hoc-d784197f.js";
import { RadioCard as v } from "./radioButton.js";
import { W as h } from "./index-c07310bf.js";
import { ButtonGroup as x } from "./buttonGroup.js";
import { Button as k } from "./button.js";
import "./index-efd35e77.js";
import "./index-93802845.js";
import "./index.es-6889c727.js";
import "./Label-079ad7bc.js";
import "./package-metadata-3dcf116a.js";
import "./index-64063129.js";
import "./FloatingLabel-922c628f.js";
import "./Button-4c83e316.js";
import "./package-metadata-9ad1330d.js";
import "./theme-b013fa81.js";
import "./ButtonGroup-a9850ef0.js";
import "./Popup-b6c9078b.js";
import "react-dom";
import "./surface-71c0d1c6.js";
import "./Dialog-a72b336a.js";
import "./FormElement-65f04cfd.js";
import "./form-2514c6d8.js";
import "./card.js";
import "./Enums-2eefd6e1.js";
import "./package-metadata-a152adb8.js";
import "./Ripple-5a8cf54c.js";
import "./icon.js";
import "./auto-scroll-b2de6e53.js";
const R = n(function({ data: r, ...i }, a) {
  const l = (r == null ? void 0 : r.map(
    (t) => typeof t == "string" ? { value: t, label: t } : { ...t, label: t.label || t.value }
  )) || [];
  return /* @__PURE__ */ m.jsx(f, { ...i, ref: a, data: l });
}), Z = c(R), $ = (e) => {
  const [r, i] = s.useState(0), a = h(
    "k-radio-list",
    {
      "k-list-horizontal": e.layout === "horizontal" || e.layout === void 0,
      "k-list-vertical": e.layout === "vertical"
    },
    e.className
  ), l = (t) => {
    i(e.data.findIndex((o) => o.value === t.value) ?? 0);
  };
  return s.useEffect(() => {
    i(e.data.findIndex((t) => t.value === e.value));
  }, [e.data, e.value]), /* @__PURE__ */ m.jsx("ul", { className: a, children: e.data.map((t, o) => /* @__PURE__ */ d(v, { ...t, key: o, checked: o === r, onChange: t.onChange || l })) });
}, j = ({
  value: e,
  onChange: r,
  data: i,
  valid: a,
  disabled: l
}) => {
  const t = (i == null ? void 0 : i.map(
    (o) => typeof o == "string" ? { value: o, label: o } : { ...o, label: o.label || o.value }
  )) || [];
  return /* @__PURE__ */ m.jsx(x, { disabled: l, children: t.map((o, u) => /* @__PURE__ */ m.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ m.jsx(
      k,
      {
        style: { width: "12.5rem", height: "2.75rem" },
        fillMode: e === o.value ? "solid" : "outline",
        themeColor: a ? "primary" : "error",
        type: "button",
        onClick: () => {
          r == null || r({ value: o.value });
        },
        selected: e === o.value,
        disabled: l,
        children: o.value
      },
      o.value
    ),
    u !== t.length - 1 ? /* @__PURE__ */ m.jsx("span", { style: { width: ".5rem" } }) : null
  ] }, u)) });
}, oo = c(j);
export {
  $ as RadioCardGroup,
  R as RadioGroup,
  Z as RadioGroupFormField,
  j as RadioTextButtonGroup,
  oo as RadioTextButtonGroupFormField
};
